import React from "react";
import { Link } from 'gatsby';

import Layout from '../components/layout';
import indexStyles from './index.module.scss';
import Head from '../components/head';

const IndexPage = () => {
  return (
    <Layout>
      <Head title="Home" />
      <h1>Hello.</h1>
      <h2>I'm Jonathan, a full-stack developer living in the DFW area of Texas.</h2>
        <p>
          You can take a look at my previous projects as well as go through some tutorial blogs.
          Just click the blog link and you will be able to check out the list of blogs. Below are
          the projects I have finished. If you click the title of the project you will be taken
          to the blog post that talks about what process I went through and the tech stack used.
      </p>
      <p>Need a developer? <Link className={indexStyles.contact} to="/contact">Contact me</Link></p>
    </Layout>
  )
}

export default IndexPage;